import FileImageIcon from './FileImageIcon';

export default FileImageIcon;
